import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";


export default function Section2ForCompanies() {


    const initStrings = {
        headingSection1: stringsTranslate(appWords.knaekapp_social_alternative_title),
        subheadingSection1_1: stringsTranslate(appWords.tired_of_socials),
        subheadingSection1_2: stringsTranslate(appWords.coupon_duration_and_visibility),
        subheadingSection1_3: stringsTranslate(appWords.real_contact_at_counter),
        playImg1: "/assets/images/ForCompanies/Visual1 1.webp",
    }

    return (
        <section className="section2-for-companies" id='Knaek-app'>
            <div className="container-fluid">

                {/*Section 2*/}
                <div className="row align-items-start justify-content-center px-2 px-md-5 px-lg-5  ">
                    <div className="col-lg-6 col-md-12 image-crop-container">
                        <img className={'img-section2-for-companies'} src={initStrings.playImg1} alt={""}/>
                    </div>
                    <div className="col-lg-6 col-md-12 flex-wrap d-flex align-items-center mt-0 mt-md-5 mt-lg-5 text-knaek-title">
                        <h1 className={"heading-section2-for-companies text-knaek-title"}>{initStrings.headingSection1}  </h1>
                            <text className={"mt-3 p-1 line-text text-knaek-title subheading-section2-for-companies"}>{initStrings.subheadingSection1_1}</text>
                            <text className={"mt-3 p-1 line-text text-knaek-title subheading-section2-for-companies"}>{initStrings.subheadingSection1_2}</text>
                            <text className={"mt-3 p-1 line-text text-knaek-title subheading-section2-for-companies"}>{initStrings.subheadingSection1_3}</text>
                    </div>

                </div>
            </div>
        </section>
    );

    function goToYouTube() {
        if (window.location.href.toString().includes("give-student-discounts")) {
            window.open('https://www.youtube.com/watch?v=viGUvE0J8iQ')

        } else {
            window.open('https://www.youtube.com/watch?v=MsbjSpcfLm8')

        }

    }
}
